module.exports = __webpack_public_path__ + "static/media/10_l_kraski_28.49_85.83.f9a05762.png";